import { featuredCover } from "@/mocks/home";

export default function FeaturedSpot() {
  return (
    <section id="spotlight" className="w-full bg-background-100">
      <div className="mx-auto w-full max-w-[1400px] px-4 py-16 md:px-6 md:py-24">
        <div className="grid grid-cols-1 items-center gap-10 lg:grid-cols-12 lg:gap-16">
          <div className="lg:col-span-7">
            <div className="relative overflow-hidden rounded-lg">
              <div className="h-[300px] w-full sm:h-[420px] lg:h-[520px]">
                <img
                  src={featuredCover.cover}
                  alt="音乐节主舞台现场实拍直击封面"
                  title="私拍吃瓜 现场实拍直击封面"
                  className="h-full w-full object-cover object-top"
                />
              </div>
              <span className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-md bg-accent-500 px-3 py-1.5 text-[11px] font-medium tracking-wider text-background-50">
                <i className="ri-bookmark-3-line text-sm" />
                {featuredCover.tag}
              </span>
            </div>
          </div>

          <div className="lg:col-span-5">
            <span className="text-[11px] tracking-[0.32em] text-secondary-500">本期主打</span>
            <h2 className="mt-4 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-3xl">
              {featuredCover.title}
            </h2>
            <p className="mt-5 text-sm leading-relaxed text-foreground-700 md:text-base">
              {featuredCover.desc}
            </p>

            <div className="mt-7 flex flex-wrap items-center gap-x-5 gap-y-2 text-xs text-foreground-600">
              <span className="flex items-center gap-1.5">
                <i className="ri-time-line text-sm text-primary-600" />
                {featuredCover.time}
              </span>
              <span className="flex items-center gap-1.5">
                <i className="ri-live-line text-sm text-accent-600" />
                {featuredCover.meta}
              </span>
            </div>

            <div className="mt-8 flex flex-col gap-3 sm:flex-row">
              <a
                href="#stream"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-medium text-background-50 transition-colors duration-200 hover:bg-primary-600"
              >
                <i className="ri-play-circle-line text-base" />
                进入现场完整记录
              </a>
              <a
                href="#collections"
                className="flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-300 bg-background-50 px-6 py-3 text-sm font-medium text-foreground-800 transition-colors duration-200 hover:bg-background-200"
              >
                <i className="ri-stack-line text-base" />
                翻同主题合集
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}